import { render } from "./PantryVirtualListItem.vue?vue&type=template&id=c0c6fa58&ts=true"
import script from "./PantryVirtualListItem.vue?vue&type=script&lang=ts"
export * from "./PantryVirtualListItem.vue?vue&type=script&lang=ts"

import "./PantryVirtualListItem.vue?vue&type=style&index=0&id=c0c6fa58&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__